<template>
    <div class="ranking-tabs-mobile mobile-only">
        <div class="form-item form-item-select">
            <div class="select-outer">
                <input type="text"
                       name="careerLevel"
                       v-model="ranking[selected].name"
                       @focus="openList = true"
                       @blur="openList = hoverList ? true : false"
                       :readonly="true">
                <ul v-show="openList && !sending && !isVerified">
                    <li v-for="(value, index) in ranking"
                        :key="index"
                        @click="setRanking(value.code), openList = false"
                        @mouseover="hoverList = true"
                        @mouseleave="hoverList = false">{{ value.name }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['ranking', 'selected', 'setRanking'],
        data () {
            return {
                openList: false,
                hoverList: false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/top-qualified/TabsMobile.vue